'use es6';

import * as client from 'DesignData/api/Revisions';
import { CUSTOM_WIDGET_REVISIONS_FETCH, GLOBAL_WIDGET_REVISIONS_FETCH, LAYOUT_REVISIONS_FETCH, TEMPLATE_REVISIONS_FETCH, RAW_ASSET_REVISIONS_FETCH } from 'DesignData/actions/ActionTypes';
export function getFetchActions(actionType) {
  return {
    request: id => {
      return {
        type: actionType,
        resourceId: id
      };
    },
    receive: (id, revisions, offset, total) => {
      return {
        type: actionType,
        resourceId: id,
        revisions,
        offset,
        total
      };
    },
    error: (id, error) => {
      return {
        type: actionType,
        resourceId: id,
        error
      };
    }
  };
}

function getFetchRevisionsAction(actionType, fetchMethod) {
  return (resourceId, offset = 0) => {
    const {
      request,
      receive,
      error
    } = getFetchActions(actionType);
    return dispatch => {
      dispatch(request(resourceId));
      return client[fetchMethod](resourceId, offset).then(result => {
        const {
          objects: revisions,
          total
        } = result;
        dispatch(receive(resourceId, revisions, offset, total));
      }).catch(_error => {
        dispatch(error(resourceId, _error));
      });
    };
  };
}

export const fetchCustomWidgetRevisions = getFetchRevisionsAction(CUSTOM_WIDGET_REVISIONS_FETCH, 'fetchCustomWidgetRevisions');
export const fetchGlobalWidgetRevisions = getFetchRevisionsAction(GLOBAL_WIDGET_REVISIONS_FETCH, 'fetchGlobalWidgetRevisions');
export const fetchLayoutRevisions = getFetchRevisionsAction(LAYOUT_REVISIONS_FETCH, 'fetchLayoutRevisions');
export const fetchTemplateRevisions = getFetchRevisionsAction(TEMPLATE_REVISIONS_FETCH, 'fetchTemplateRevisions');
export const fetchRawAssetRevisions = getFetchRevisionsAction(RAW_ASSET_REVISIONS_FETCH, 'fetchRawAssetRevisions');